import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { Provider } from "react-redux";
import "react-phone-number-input/style.css";

import { store } from "./duck";
import IridexApp from "./IridexApp";

import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "./style/main.scss";
import axiosDefaults from "@util/axiosDefaults";

class ReactApp extends React.Component {
  state = {};

  render() {
    return (
      <Provider store={store}>
        <IridexApp style={{ height: "100%" }} />
      </Provider>
    );
  }
}

ReactDOM.render(
  <ReactApp style={{ height: "100%" }} />,
  document.getElementById("app")
);

if (module.hot) {
  module.hot.accept();
}
